import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import { BiData, DeviationEditClickBiEvent } from '@wix/da-bi/pkg/events';
import EditIcon from '@wix/da-ds/pkg/Icons/24x24/Edit';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarEditButton from '../../_partials/items/ActionBarEditButton';
import { useEditDeviationAction } from '../../actionHooks/useEditDeviationAction';

export interface Props {
  deviation: PapiDeviation;
}

export const EditButton: React.FC<React.PropsWithChildren<Props>> = ({ deviation }) => {
  const { t } = useTranslation();
  const onClick = useEditDeviationAction(deviation);
  return (
    <ActionBarItemWrapper tooltip={t('actionbar.edit')}>
      <ActionBarEditButton
        onClick={onClick}
        biData={BiData<DeviationEditClickBiEvent>({
          evid: 371,
          typeid: getDeviationResourceType(deviation),
          itemid: deviation.deviationId,
        })}
      >
        <ActionBarIcon icon={EditIcon} />
      </ActionBarEditButton>
    </ActionBarItemWrapper>
  );
};
EditButton.displayName = 'EditButton';

export default EditButton;
